import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/components/HomePage.vue'
import Portfolio from '@/components/PortoFolio.vue'
import Contact from '@/components/ContactUs.vue'
import PortoDetail from './components/PortoDetail.vue'
import PrivacyPolicy from './components/PrivacyPolicy.vue'
import ErrorE404 from './components/ErrorE404.vue'
const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/portfolio', name: 'Portfolio', component: Portfolio },
  { path: '/portfolio/:slug', name: 'PortoDetail', component: PortoDetail },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/privacy', name: 'PrivacyPolicy', component: PrivacyPolicy },
  { path: '/:pathMatch(.*)*', name: 'ErrorE404', component: ErrorE404 }
]

export default createRouter({
  history: createWebHistory(),
  routes
})
